import { Injectable } from '@angular/core'
import { convertExtensionToMimeType } from './utils'

export type DownloadFileFormat = 'pdf' | 'docx' | 'csv' | 'json'

@Injectable({
  providedIn: 'root',
})
export class DownloadsService {
  downloadData(data: any, fileName: string, format: DownloadFileFormat) {
    const blob = new Blob([data], { type: convertExtensionToMimeType(format) })
    const link = document.createElement('a')
    document.body.appendChild(link)
    link.download = fileName
    link.href = window.URL.createObjectURL(blob)
    link.click()
  }

  downloadFromUrl(url: string) {
    const a = document.createElement('a')
    a.href = url
    a.download = url.split('/').pop()!
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}
